import React from 'react';
// Note: Avoid AI-like icons for Artmosphere aesthetic

const CustomModal = ({ isOpen, onClose, onConfirm, title, message, confirmText = "Confirm", cancelText = "Cancel", type = "warning" }) => {
  if (!isOpen) return null;

  const getBannerStyle = () => {
    switch (type) {
      case 'success':
        return 'bg-gradient-to-r from-amber-500 to-orange-400';
      case 'error':
        return 'bg-gradient-to-r from-rose-500 to-red-400';
      default:
        return 'bg-gradient-to-r from-amber-500 to-orange-400';
    }
  };

  const getButtonStyle = () => {
    switch (type) {
      case 'success':
        return "bg-gradient-to-r from-amber-500 to-orange-400 hover:from-amber-600 hover:to-orange-500";
      case 'error':
        return "bg-gradient-to-r from-red-500 to-red-400 hover:from-red-600 hover:to-red-500";
      default:
        return "bg-gradient-to-r from-amber-500 to-amber-400 hover:from-amber-600 hover:to-amber-500";
    }
  };

  // Check if this is a success/error modal (only OK button)
  const isInfoModal = type === 'success' || type === 'error';

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-white/10 backdrop-blur-md"
        onClick={onClose}
      />
      
      {/* Modal */}
      <div className="relative bg-white/95 backdrop-blur-md border-2 border-amber-200 rounded-2xl p-0 shadow-2xl max-w-md w-full mx-4 overflow-hidden transform transition-all duration-300 scale-100">
        {/* Top banner */}
        <div className={`${getBannerStyle()} text-white text-center py-3 font-semibold`}></div>
        
        {/* Title */}
        <h3 className="text-2xl font-bold text-amber-800 text-center mt-6 mb-2 px-6">
          {title}
        </h3>
        
        {/* Message */}
        <p className="text-amber-700 text-center mb-8 leading-relaxed px-6">
          {message}
        </p>
          
        {/* Buttons */}
        <div className="flex gap-4 justify-center pb-6">
          {!isInfoModal && (
              <button
                onClick={onClose}
              className="px-6 py-3 bg-gradient-to-r from-gray-400 to-gray-300 hover:from-gray-500 hover:to-gray-400 text-white font-semibold rounded-xl shadow-lg transition-all duration-300 transform hover:scale-105"
              >
              {cancelText}
              </button>
            )}
            <button
            onClick={() => {
              if (!isInfoModal) {
                onConfirm();
              }
              onClose();
            }}
            className={`px-6 py-3 ${getButtonStyle()} text-white font-semibold rounded-xl shadow-lg transition-all duration-300 transform hover:scale-105`}
            >
            {confirmText}
            </button>
        </div>
      </div>
    </div>
  );
};

export default CustomModal; 